<template>
  <div class="hello">

    <b-container>
        <b-row>
            <b-col>
                <h4>Make Account</h4>
            </b-col>
        </b-row>

        <!-- Account type -->
        <accounttype v-if="showAccountType" @accounttypedone="accounttypedone"></accounttype>

        <!-- Terms -->
        <terms v-if="showTerms" @previous="showtype" @next="showcontact"></terms>

        <!-- Contact -->
        <contactinfo v-if="showContact"  @previous="showterms" @next="showemail"></contactinfo>

        <!-- Email -->
        <accountsetup v-if="showEmail"  @previous="showcontact" @next="signupuser"></accountsetup>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Accounttype from './Accounttype.vue';
import Terms from './Terms.vue';
import Contactinfo from './Contactinfo.vue';
import Accountsetup from './Accountsetup.vue';

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'newUserContactPhone', 'newUserCompany'])
    },

    components: {
        Accounttype,
        Terms,
        Contactinfo,
        Accountsetup,
    },

    data() {
        return {
            showAccountType:false,
            showTerms:false,
            showContact:false,
            showCounties:false,
            showEmail:false,

        }
    },

    methods:{
        //User selected an account type
        accounttypedone(){
            console.log("accounttypedone done")
            this.showAccountType=false
            this.showTerms=true
        },

        //User accepted terms and conditions
        termsdone(){
            console.log("Terms and conditions done")
        },

        //Show account type
        showtype(){
            this.showAccountType=true
            this.showTerms=false
            this.showContact=false
            this.showCounties=false
            this.showEmail=false

        },

        //Show account type
        showterms(){
            this.showAccountType=false
            this.showTerms=true
            this.showContact=false
            this.showCounties=false
            this.showEmail=false

        },

        //Show contact info
        showcontact(){
            this.showAccountType=false
            this.showTerms=false
            this.showContact=true
            this.showCounties=false
            this.showEmail=false

        },

        //Show email info
        showemail(){
            this.showAccountType=false
            this.showTerms=false
            this.showContact=false
            this.showCounties=false
            this.showEmail=true

        },

        signupuser(){

        },

    },

    mounted(){
        //this.$store.commit('setNewUserAddress', {})
        this.showAccountType=true
    },
}
</script>

